const apiUrl = process.env.REACT_APP_API_URL;

export const getInventoryReports = async (
    categoryId,
    StatusId,
    { page = 1, pageSize = 10, folioText = '', movementType = '', supplyText = '' } = {}
) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/getInventoryReport1/${categoryId}/${StatusId}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ page, pageSize, folioText, movementType, supplyText }),
    });

    try {
        return await res.json();
    } catch {
        return { rows: [], count: 0, page, pageSize };
    }
};

export const getInventoryReportFoliosDetailed = async (
    categoryId,
    statusId,
    folioText = '',
    movementType = '',
    visibleItemIds = []
) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/getInventoryReportFoliosDetailed/${categoryId}/${statusId}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            folioText,
            movementType,
            visibleItemIds,
        }),
    });

    try {
        return await res.json();
    } catch {
        return [];
    }
};

export const getInventoryReportFolios = async (
    categoryId,
    statusId,
    folioText = '',
    movementType = '',
    visibleItemIds = []
) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/getInventoryReportFolios/${categoryId}/${statusId}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            folioText,
            movementType,
            visibleItemIds,
        }),
    });

    try {
        return await res.json();
    } catch {
        return [];
    }
};

export const getSoldFolioRanges = async ({ saleId = 0, categoryId = 0, folioText = '' } = {}) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/reports/sold-folios/ranges`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ saleId, categoryId, folioText }),
    });
    try { return await res.json(); } catch { return []; }
};

export const getSoldFoliosDetailed = async ({ saleId = 0, categoryId = 0, folioText = '' } = {}) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/reports/sold-folios/detailed`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ saleId, categoryId, folioText }),
    });
    try { return await res.json(); } catch { return []; }
};

export const getInventoryReportTotals = async (categoryId, StatusId, folioText = '', movementType = '', supplyText = '') => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/getInventoryReportTotals/${categoryId}/${StatusId}`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ folioText, movementType, supplyText }),
    });
    try { return await res.json(); } catch (e) { return []; }
};

export const getInventoryReportFull = async (categoryId, StatusId, folioText = '', movementType = '', supplyText = '') => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/items/getInventoryReportFull/${categoryId}/${StatusId}`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ folioText, movementType, supplyText }),
    });
    try { return await res.json(); } catch (e) { return []; }
};